import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
import { computed } from 'vue'
type Props = {
  text: string
  color?: string
  children?: Props[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BadgeListItem',
  props: {
    text: {},
    color: {},
    children: {}
  },
  setup(__props: any) {

const props = __props
const tooltip = computed(() => {
  if (props.children && props.children.length > 0) {
    return props.children.map((child) => child.text).join('\n')
  }
  return undefined
})
const computedStyle = computed(() => {
  if (props.color) {
    return { 'background-color': props.color }
  }
  return { 'background-color': '#e0e0e0' }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (tooltip.value)
        ? (_openBlock(), _createBlock(TooltipStandardV2, {
            key: 0,
            text: tooltip.value,
            arrowPosition: 'top-center',
            "vertical-offset": 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "badge-list-item",
                style: _normalizeStyle(computedStyle.value)
              }, _toDisplayString(_ctx.text), 5)
            ]),
            _: 1
          }, 8, ["text"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "badge-list-item",
            style: _normalizeStyle(computedStyle.value)
          }, _toDisplayString(_ctx.text), 5))
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "badge-list-item-separator" }, null, -1))
  ], 64))
}
}

})